import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 80,
    marginBottom: 56,
    [theme.breakpoints.down("lg")]: {
      marginTop: 60,
      marginBottom: 36,
      },
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 32,
    },
  },
  title: {
    marginBottom: 18,
  },
  regular: {
    fontSize: 22,
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  },
}));

const CancerMainHeader = ({ cancer = "폐암", sub = false }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      className={classes.header}
    >
      <Typography variant="h2" className={classes.title}>
        나의 {cancer} 발생 위험도 {!sub && "결과"}
      </Typography>
      {sub && (
        <Typography variant="h4" color="textSecondary" align="center" className={classes.regular}>
          입력하신 결과는 다음과 같습니다. <br />이 정보를 기준으로 위험도를
          계산합니다.
        </Typography>
      )}
    </Grid>
  );
};

export default CancerMainHeader;
